module.exports = __webpack_public_path__ + "static/8-9dc60aba28e567101706bd7e58fef6c6.png";